import DesktopSubmissionDetails from './DesktopSubmissionDetails';
import DesktopSubmissionDetailsNewDescriptionLayout from '../DesktopSubmissionDetails.new_description_layout';
import { withFeatureBranch } from '../../redux/flags';
export default withFeatureBranch({
    new_description_layout: DesktopSubmissionDetailsNewDescriptionLayout,
})(DesktopSubmissionDetails);
//# sourceMappingURL=index.js.map